import { IArea, AreaTypes, ICoord, ICoordXY, ICoordXYXY, IUserStatus, UserStatusPriority } from '../../models/types';

const getPolygonPositions = (positions: ICoord): Array<[number, number]> => {
  // приводим к порядку latlon
  const TempPositions = positions.slice(0);
  for (let i = 0; i < TempPositions.length - 1; i += 2) {
    [TempPositions[i], TempPositions[i + 1]] = [TempPositions[i + 1], TempPositions[i]];
  }
  // оборачиваем в отдельные массивы
  const result = TempPositions.reduce<number[][]>(
    (acc, coord) => {
      const lastEl = acc.length - 1;

      if (acc[lastEl].length < 2) {
        acc[lastEl].push(coord);
      } else {
        acc.push([coord]);
      }

      return acc;
    },
    [[]]
  );
  return result as Array<[number, number]>;
};

const getBoxCenter = ([x, y, z, w]: ICoord): ICoordXY => {
  return [y + w, x + z].map(coord => coord / 2) as ICoordXY;
};

const getBoxBounds = ([x, y, z, w]: ICoord): ICoordXYXY => {
  return [
    [y, x],
    [w, z]
  ];
};

const getCircleCenter = ([x, y, z]: ICoord): ICoordXY => {
  return [y, x];
};

const getCircleRadius = ([x, y, z]: ICoord): number => {
  return z;
};

// Bounds зоны в leaflet-порядке [[lat,lng],[lat,lng]] для подгонки обзора.
// geo-режим использует глобальные координаты, режим плана — локальные.
// Для неподдерживаемой геометрии (Marker) или пустых координат — null.
const getAreaBounds = (area: IArea, isGeo: boolean): ICoordXYXY | null => {
  const coords = isGeo ? area.geomGlobalCoords : area.geomCoords;

  if (!coords || coords.length < 3) {
    return null;
  }

  switch (area.geomType) {
    case AreaTypes.Box: {
      if (coords.length < 4) {
        return null;
      }

      return getBoxBounds(coords);
    }
    case AreaTypes.Circle: {
      const [lat, lng] = getCircleCenter(coords);
      const radius = getCircleRadius(coords);

      return [
        [lat - radius, lng - radius],
        [lat + radius, lng + radius]
      ];
    }
    case AreaTypes.Polygon: {
      // плоский массив парами [lng, lat]: минимум 3 точки, чётная длина
      if (coords.length < 6 || coords.length % 2 !== 0) {
        return null;
      }

      const positions = getPolygonPositions(coords);

      if (!positions.length) {
        return null;
      }

      return positions.reduce<ICoordXYXY>(
        (bounds, [lat, lng]) => [
          [Math.min(bounds[0][0], lat), Math.min(bounds[0][1], lng)],
          [Math.max(bounds[1][0], lat), Math.max(bounds[1][1], lng)]
        ],
        [
          [Infinity, Infinity],
          [-Infinity, -Infinity]
        ]
      );
    }
    default:
      return null;
  }
};

const getUserStatuses = (statuses: IUserStatus[]) => {
  return statuses.filter(
    ({ priority }) =>
      priority !== UserStatusPriority.HIDDEN && priority !== UserStatusPriority.NORMAL
  );
};

export {
  getPolygonPositions,
  getBoxCenter,
  getBoxBounds,
  getCircleCenter,
  getCircleRadius,
  getAreaBounds,
  getUserStatuses
};
